import { CheckboxField } from '@calendly/ui/form/checkbox-field';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const meetingCardContainerHasUrlCss = "m13afdb6";
const meetingCardContainerIsFetchingCss = "myen9b5";
const meetingCardContainerIsListViewCss = "m16dyzqo";
const meetingCardContainerIsSelectedCss = "m17bp2yf";
const checkboxContainerCss = "c1sn4llf";

// TODO: Change border back to 1px solid ${colorStrokeStandard}
const meetingCardContainerCss = "myvu74t";
export const MeetingCardContainer = forwardRef((props, ref) => {
  const {
    hasUrl,
    isFetching,
    isListView,
    isSelected,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(meetingCardContainerCss, {
    [meetingCardContainerHasUrlCss]: hasUrl,
    [meetingCardContainerIsFetchingCss]: isFetching,
    [meetingCardContainerIsListViewCss]: isListView,
    [meetingCardContainerIsSelectedCss]: isSelected
  }, props.className)} />;
});
export const CheckboxContainer = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(checkboxContainerCss, props.className)} />);
const thumbnailWrapperCss = "t1huf2ui";
export const ThumbnailWrapper = props => <div {...props} className={classNames(thumbnailWrapperCss, props.className)} />;
const gridViewCheckboxWrapperCss = "g111sbdg";
const gridViewCheckboxFieldCss = "gu2xd7z";
export const GridViewCheckboxWrapper = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(gridViewCheckboxWrapperCss, props.className)} />);
export const StyledCheckboxField = forwardRef((props, ref) => <CheckboxField ref={ref} {...props} className={classNames(gridViewCheckboxFieldCss, props.className)} />);
const thumbnailContainerCss = "tlvk9t5";
const thumbnailContainerIsListViewCss = "tcxcsk0";
export const ThumbnailContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    isListView,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(thumbnailContainerCss, {
    [thumbnailContainerIsListViewCss]: isListView
  }, props.className)} />;
});
const thumbnailLoaderCss = "t496iru";
export const ThumbnailLoader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(thumbnailLoaderCss, props.className)} />;
});
const thumbnailCss = "t1d29a6c";
export const Thumbnail = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  return <Component ref={ref} {...restProps} className={classNames(thumbnailCss, props.className)} />;
});
const thumbnailPlaceholderCss = "tegt283";
export const ThumbnailPlaceholder = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(thumbnailPlaceholderCss, props.className)} />;
});
const meetingTimeBadgeCss = "m18dedax";
export const MeetingTimeBadge = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    isListView,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(meetingTimeBadgeCss, props.className)} />;
});
const sampleBadgeCss = "sdzgv2t";
export const SampleBadge = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sampleBadgeCss, props.className)} />;
});
const spacerCss = "s1yn4az";
const spacerIsListViewCss = "s1saph6z";
export const FlexSpacer = forwardRef((props, ref) => {
  const {
    isListView,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(spacerCss, {
    [spacerIsListViewCss]: isListView
  }, props.className)} />;
});
const bodyContainerIsListViewCss = "bfycu2s";
const bodyContainerCss = "blvzr8f";
export const BodyContainer = forwardRef((props, ref) => {
  const {
    isListView,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(bodyContainerCss, {
    [bodyContainerIsListViewCss]: isListView
  }, props.className)} />;
});
const nameContainerCss = "n1ladhq3";
export const NameContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(nameContainerCss, props.className)} />;
});
const styledNameIsPhoneCss = "s4m9nem";
const styledNameIsTitleCss = "sm3z63o";
const styledNameIsSmallCss = "ska8byp";
const styledNameCss = "spcyguc";
export const StyledName = forwardRef((props, ref) => {
  const {
    isTitle,
    isSmall,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(styledNameCss, {
    [styledNameIsPhoneCss]: isPhone,
    [styledNameIsTitleCss]: isTitle,
    [styledNameIsSmallCss]: isSmall
  }, props.className)} />;
});
const dateTimeChildItemCss = "dtgsqt9";
const dateTimeContainerIsListViewCss = "dhi6l1n";
const dateTimeContainerCss = "dv5i3jv";
export const DateTimeContainer = forwardRef((props, ref) => {
  const {
    isListView,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dateTimeContainerCss, {
    [dateTimeContainerIsListViewCss]: isListView
  }, props.className)} />;
});
const metadataDotCss = "m1l86j9u";
export const MetadataDot = forwardRef((props, ref) => <span ref={ref} {...props} className={classNames(metadataDotCss, dateTimeChildItemCss, props.className)} />);
const timeContainerCss = "ti5dr5d";
export const TimeContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timeContainerCss, dateTimeChildItemCss, props.className)} />;
});
const dateContainerCss = "dsbc5vm";
const ownedByContainerCss = "o9z05as";
export const OwnedByContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(ownedByContainerCss, dateTimeChildItemCss, props.className)} />;
});
export const DateContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dateContainerCss, dateTimeChildItemCss, props.className)} />;
});
const linkWrapperCss = "l1okhaek";
export const LinkWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'a';
  return <Component ref={ref} {...restProps} className={classNames(linkWrapperCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");